import * as yup from 'yup'

export const FORMIK_VALUE = {
  PASSWORD: 'Password',
  CONFIRM_PASSWORD: 'Confirm_Password'
}

export const VALIDATION_SCHEMA = yup.object({
  [FORMIK_VALUE.PASSWORD]: yup.string()
    .required('This field is required')
    .matches(
      /^.*(?=.{12,})((?=.*[!@#$%^&*()\-_=+{};:,<.>]){1})(?=.*\d)((?=.*[a-z]){1})((?=.*[A-Z]){1}).*$/,
      'Password must be at least 12 characters, contain uppercase and lowercase letters, at least one symbol and at least one number.'
    ),
  [FORMIK_VALUE.CONFIRM_PASSWORD]: yup.string()
    .required('This field is required')
    .test('passwords-match', 'The password confirmation does not match', function (value) {
      return value === this.parent[FORMIK_VALUE.PASSWORD]
    })
})
